export function isOwnerRole(role: string, orgType?: string): boolean {
  if (orgType === 'club' && role === 'manager') return true
  if (orgType === 'outfitter' && role === 'outfitter') return true
  return false
}

export function isTrackingOnlyRole(role: string, orgType?: string): boolean {
  if (orgType === 'club' || orgType === 'crew') return role === 'guest'
  return role === 'client'
}

export function isGuideEligibleRole(role: string, orgType?: string): boolean {
  if (orgType && orgType !== 'outfitter') return false
  return isOwnerRole(role, 'outfitter') || role === 'guide'
}
